import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import LightBox from '@bd/bdui-lightbox';
// import YoutubeThumbnail from '@bd/bdui-youtubethumbnail';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';

import { colors } from '../styles';

const styles = css`
  padding: 10px 0 100px;
  .VideoGallery_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
  .VideoGallery_wrapper div {
    width: 100%;
    max-width: 600px;
    height: auto;
    cursor: pointer;
    position: relative;
    margin: 15px;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: ${colors.black};
      justify-content: center;
      align-items: center;
      z-index: 2;
      transition: all .3s ease-out;
      opacity: .2;
    }
    &:hover {
      &::after {
        background-color: ${colors.brand1};
        opacity: .75
      }
    }
  }
  .VideoItem_image {
    width: 100%;
    height: auto;
    position: relative;
    z-index: 1;
  }
  .VideoItem_playButton {
    cursor: pointer;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-image: url("/images/icon-play-button-white.svg");
    background-position: center center;
    background-size: 90px 90px;
    background-repeat: no-repeat;
    display: block;
    z-index: 3;
  }
`;

const videoCss = css`
  margin: 10vh auto 0;
  @media (min-width: 992px) {
    width: 75vw;
    margin: 10vh auto 0;
  }
`;

function VideoGalleryList({ videoCollection }) {
  return (
    <div className={styles}>
      <div className="VideoGallery_wrapper">
        {
          videoCollection.map(item => (
            <LightBox
              key={item._id}
              items={[
                {
                  element: (
                    <div
                      className={`${videoCss} embed-responsive embed-responsive-16by9`}
                      dangerouslySetInnerHTML={SanitizeHtml(item.video)}
                    />
                  ),
                },
              ]}
            >
              <Image
                src={get(item, 'thumbnail.contentUrl')}
                alt={get(item, 'thumbnail.name', get(item, 'thumbnail.caption', ''))}
                className="VideoItem_image"
                width={600}
                height={337}
                exact
              />
              <span className="VideoItem_playButton" />
            </LightBox>
          ))
        }
      </div>
    </div>
  );
}

VideoGalleryList.propTypes = {
  videoCollection: PropTypes.arrayOf(PropTypes.object),
};

VideoGalleryList.defaultProps = {
  videoCollection: undefined,
};

export default (VideoGalleryList);



// WEBPACK FOOTER //
// ./src/components/PageVideoGalleryList.js